import { useTranslation } from "react-i18next";
import { Space, Table } from "antd";
import usePatients from "@/hooks/usePatients";
import { Patient } from "@/root/models/patient";
import useModalOpen from "@/hooks/useModalOpen";
import PatientsTableActions from "./components/PatientsTableActions";
import CreatePatient from "./components/CreatePatient";

const Patients = () => {
  const { t } = useTranslation();
  const { patients, getPatientsLoading } = usePatients({});

  const { modal, onHandleCancel, onEditSuccess, isModalOpen } = useModalOpen();

  const patientsColumn = [
    {
      title: t("Ім'я.name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Дата народження"),
      dataIndex: "birthDate",
      key: "birthDate",
    },
    {
      title: t("Телефон"),
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "E-mail",
      dataIndex: "mail",
      key: "mail",
    },
    {
      title: "",
      key: "action",
      render: (_: any, patient: Patient) => (
        <PatientsTableActions
          onEditSuccess={onEditSuccess}
          modal={modal}
          onCancel={onHandleCancel}
          onModalOpen={() => {
            isModalOpen(patient.patientUUID);
          }}
          patient={patient}
        />
      ),
    },
  ];

  return (
    <Space direction="vertical">
      <CreatePatient />
      <Table
        style={{ userSelect: "none" }}
        columns={patientsColumn}
        dataSource={patients.map((p) => ({ ...p, key: p.patientUUID }))}
        pagination={false}
        loading={getPatientsLoading}
        onRow={(patient) => ({
          onDoubleClick: () => isModalOpen(patient.patientUUID),
        })}
      />
    </Space>
  );
};

export default Patients;
